import { ajaxCall } from "@/shared/connection/ajax-call";
import { makeLogger } from "@/shared/consola";
import { handleErrorByMessage } from "@/shared/connection/with-store-error-handlers";
import { ToolAppTypes } from "@/shared/tool-app.types";
import { SkimmedToolProjectData } from "@/apps/page/project/tool-project-data";

const logger = makeLogger("page-tools.service");

const PAGE_ENDPOINT = `/pages`;

type ProjectsByToolType = Record<ToolAppTypes, SkimmedToolProjectData[]>;

export const pageToolsService = {
    emptyState(): ProjectsByToolType {
        return {
            banner: [],
            coffee: [],
            cookie: [],
            faq: [],
            legal: [],
            love: [],
            page: [],
            player: [],
            pricing: [],
            ticker: [],
            timer: [],
        };
    },
    getAllUserToolProjects() {
        logger.trace("getAllUserToolProjects called");
        return ajaxCall
            .get(`${PAGE_ENDPOINT}/projects`)
            .catch(handleErrorByMessage()) as unknown as Promise<ProjectsByToolType>;
    },
    createNewProject(body: { sectionId: number; tool: string; projectName: string; lang: string }) {
        logger.trace("createNewProject called");
        return ajaxCall.post(`${PAGE_ENDPOINT}/projects`, body).catch(handleErrorByMessage());
    },
};
